import { render, staticRenderFns } from "./ThumbnailMediaSetting.vue?vue&type=template&id=c04884ee&"
import script from "./ThumbnailMediaSetting.vue?vue&type=script&lang=js&"
export * from "./ThumbnailMediaSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports